import { useEffect } from 'react';
import useLogout from "./useLogout.js";
/**
 * Log the user out and redirect them to login.
 *
 * To be used as a catch-all route for anonymous users in a secure app.
 *
 * @see CoreAdminRoutes
 */
export var LogoutOnMount = function () {
    var logout = useLogout();
    useEffect(function () {
        logout();
    }, [logout]);
    return null;
};
//# sourceMappingURL=LogoutOnMount.js.map